<i18n>
{
  "en": {
    "more": "See more",
    "description": "Fill missing product information in order to improve Dynameat predictions"
  },
  "es": {
    "more": "Ver más",
    "description": "Completa la información de tus productos para mejorar las predicciones de Dynameat"
  }
}
</i18n>
<template>
  <div>
    <v-row>
      <v-col cols="4">
        <product-radar :kpis="kpis" class="radarGraph" :isLoading="radarLoading"
                       :productName="productName"/>
      </v-col>
      <v-col cols="7">
        <product-bar color="primary" class="barGraph" :startDate="startDate" :endDate="endDate"
                     :evolutives="evolutives" @date-change="onDateChange"
                     :isLoading="evolutiveLoading" :services="serviceList"/>
      </v-col>
      <v-col cols="1">
        <v-btn icon primary @click="onClickClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import { Prop, Watch } from 'vue-property-decorator';
import ProductBar from './ProductBar.vue';
import ProductRadar from './ProductRadar.vue';

@Component
@Components({ ProductRadar, ProductBar })
@MapGetters(['allowedRadarKpis', 'allowedEvolutiveKpis', 'isLoading', 'serviceList'])
@MapActions(['getProductRadarKpis', 'calculateEvolutiveKPI', 'setLoading'])
export default class ProductKpiPanel extends Vue {
  @Prop({ String, required: true }) productGuid;

  @Prop({ String, required: true }) productName;

  radarLoading = false;

  evolutiveLoading = false;

  startDate = null;

  endDate = null;

  serviceGuid = null;

  kpis = {
    speed: null,
    stock: null,
    margin: null,
    crossSelling: null,
    popularity: null,
    strategic: null,
  };

  evolutives = {
    price: {},
    sales: {},
    margin: {}
  };

  async getProductRadar(productGuid) {
    this.radarLoading = true;
    this.kpis = await this.getProductRadarKpis(productGuid);
    this.radarLoading = false;
  }

  async getProductEvolutive(productGuid, startDate, endDate, serviceGuid) {
    this.evolutiveLoading = true;
    this.evolutives = await this.calculateEvolutiveKPI({
      productGuid, startDate, endDate, serviceGuid
    });
    this.evolutiveLoading = false;
  }

  onDateChange(startDate, endDate, serviceGuid) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.serviceGuid = serviceGuid;
    this.getProductEvolutive(this.productGuid, this.startDate, this.endDate, this.serviceGuid);
  }

  onClickClose() {
    this.$emit('close');
  }

  @Watch('productGuid')
  onActiveChange(newProductGuid) {
    this.getProductRadar(newProductGuid);
    this.getProductEvolutive(newProductGuid, this.startDate, this.endDate, this.serviceGuid);
  }

  created() {
    const twoWeeksAgo = new Date();
    twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    this.startDate = twoWeeksAgo;
    this.endDate = yesterday;
    this.getProductRadar(this.productGuid);
    this.getProductEvolutive(this.productGuid, this.startDate, this.endDate, this.serviceGuid);
  }
}
</script>

<style scoped>
</style>
